import globalHTML from './global-html';
import globals from './globals';

export default {
  globalHTML,
  globals,
};
